import { render, staticRenderFns } from "./EmployeeCard.vue?vue&type=template&id=e54487e4"
import script from "./EmployeeCard.ts?vue&type=script&lang=ts&external"
export * from "./EmployeeCard.ts?vue&type=script&lang=ts&external"
import style0 from "./EmployeeCard.vue?vue&type=style&index=0&id=e54487e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports